import {translationStore} from "../../store/translationStore";

import translates from "./translates.json";

export const tr = (key) => {
    const {translationData} = translationStore;
    return translationData?.[key] || translates[key];
}